import React from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Button, Subheading, PageActions } from '@shopify/polaris';
import DispatchControlOrders from '@presentational/dispatch_control/DispatchControlOrders';
import CopyToClipboardProvider from '@container/CopyToClipboardProvider';
import axios from '@utils/axios';
import translations from '@shopify/polaris/locales/es.json';
import reduce from 'lodash/reduce';

const propTypes = {
  dispatch_control: PropTypes.object.isRequired,
  pdfURL: PropTypes.string.isRequired,
  tookanDeliveryURL: PropTypes.string.isRequired,
  delivered: PropTypes.bool.isRequired,
}

const defaultProps = {

}

class DispatchControlShow extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      dispatch_control: props.dispatch_control,
      loading: false,
      delivered: props.delivered,
    }
  }

  postToTookan = async () => {
    this.setState({loading: true});
    try {
      const response = await axios.post(this.props.tookanDeliveryURL, {});
      const data = response.data;
      console.log(response.data);
      if(data.success){
        this.setState({
          delivered: true,
        });
        alert("Enviado correctamente.")
      }
      else{
        alert("Ocurrio un error en el proceso de envio con Tookan.")
      }
    } catch (error) {
      alert("Ocurrio un error con el servidor.")
    }
    this.setState({loading: false});
  }

  render() {
    const { dispatch_control } = this.state;
    const title = `${I18n.t("activerecord.models.dispatch_control.one")} ${dispatch_control.display_id}`;
    
    
    let ids = dispatch_control.dispatch_orders[0].shopify_id; // when only one.
    
    if(dispatch_control.dispatch_orders.length > 1){
      ids = reduce(dispatch_control.dispatch_orders, (str, order) => {
        if(typeof(str) == "string"){
          return `${str},${order.shopify_id}`;
        }
        else{
          // str == first element on first iteration
          return `${str.shopify_id},${order.shopify_id}`;
        } 
      });
    }
    
    return(
      <AppProvider i18n={translations}>
        <CopyToClipboardProvider
          value={ ids }
        >
          { ({copyToClipboard}) => 
            <Page
              breadcrumbs={[{content: I18n.t("actions.back"), url: '/admin/dispatch_controls'}]}>
              <div className="mb20 flex alignItemsCenter">
                <h1 className="Polaris-DisplayText Polaris-DisplayText--sizeLarge mr10">
                  { title }
                </h1>
                <span>{ dispatch_control.created_at_text }</span>
              </div>
              <Subheading>
                {I18n.t("activerecord.models.courier", { count: 1 })}: {dispatch_control.courier.name}
              </Subheading>
              <div className="mt20 mb20">
                <DispatchControlOrders orders={dispatch_control.dispatch_orders} />
              </div>

              <PageActions 
                primaryAction={{
                  external: true,
                  url: `${this.props.pdfURL}.pdf`,
                  content: "Exportar PDF",
                  loading: this.state.loading,
                }}
                secondaryActions={[
                  {
                    content: "Copias IDs",
                    onAction: copyToClipboard,
                    loading: this.state.loading,
                  },
                ]}
              />
            </Page>
          }
        </CopyToClipboardProvider>
      </AppProvider>
    )
  }
}

DispatchControlShow.propTypes = propTypes;
DispatchControlShow.defaultProps = defaultProps;

export default DispatchControlShow;
